import { render, staticRenderFns } from "./PLOdontologos.vue?vue&type=template&id=64a799e4&scoped=true&"
import script from "./PLOdontologos.vue?vue&type=script&lang=js&"
export * from "./PLOdontologos.vue?vue&type=script&lang=js&"
import style0 from "./PLOdontologos.vue?vue&type=style&index=0&id=64a799e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a799e4",
  null
  
)

export default component.exports